<template>
  <div>
    <Divider orientation="left" style="margin-bottom: 0px;">基础信息</Divider>
    <Row class="p-b-5 p-t-10">
      <i-col span="8"
        ><span class="title text-title-65">名称 </span>{{ debtInfo.name }}</i-col
      >
      <i-col span="8"
        ><span class="title text-title-65">所属客户 </span>{{ debtInfo.advertiserName }}</i-col
      >
      <i-col span="8"
        ><span class="title text-title-65">创建时间 </span>{{ debtInfo.createTime }}</i-col
      >
    </Row>
    <Row>
      <i-col span="8"
        ><span class="title text-title-65">创建人 </span>{{ debtInfo.userName }}</i-col
      >
      <i-col span="8"
        ><span class="title text-title-65">周期 </span>第 {{ debtInfo.termNumber }}期</i-col
      >
      <i-col span="8">
        <span class="title text-title-65">状态 </span>
        <Tag v-if="debtInfo.status === 0">{{ debtInfo.statusName }}</Tag>
        <Tag v-else type="border" color="green">{{ debtInfo.statusName }}</Tag>
      </i-col>
    </Row>
    <Row>
      <i-col span="24"
        ><span class="title text-title-65">描述 </span>{{ debtInfo.description || "-" }}</i-col
      >
    </Row>

    <Divider orientation="left" style="margin-bottom: 0px;">费用清单</Divider>
    <Row v-for="(item,index) in feeData" :key="index" class="m-b-5">
      <i-col flex="100px">
        {{ item.feeTypeName }}
      </i-col>
      <i-col flex="100px" class="text-right">
        {{ formatMoney(item.amount) }}
      </i-col>
    </Row>
    <Row class="m-b-5">
      <i-col flex="100px">
        调差项
      </i-col>
      <i-col flex="100px" class="text-right warning text-bold">
        {{ formatMoney(debtInfo.adjustAmount) }}
      </i-col>
      <i-col flex="auto" class="p-l-5" v-if="debtInfo.status!==3">
        <a @click="hanhandleChangeMoney"><Icon type="md-create" />设置</a>
      </i-col>
    </Row>
    <Row><i-col flex="200px"><hr/></i-col></Row>
    <Row class="m-b-5">
      <i-col flex="100px">
        合计
      </i-col>
      <i-col flex="100px" class="text-right">
        {{ debtTotalAmount }}
      </i-col>
    </Row>

    <Divider orientation="left" style="margin-bottom: 0px;">收款明细</Divider>
    <Row class="p-b-5">
      <i-col span="24">
        <span class="title text-title-85">预计付款日期 </span>
        {{ debtInfo.lastDate }}
        <Button v-if="debtInfo.status!==3" type="success" size="small" icon="md-bulb" class="m-l-10" @click="handleFinishDebt">标记收款</Button>
        <Button type="success" size="small" class="m-l-10" icon="md-download" @click="handleExportNotify">导出缴费通知单</Button>
      </i-col>
    </Row>
    <template v-if="debtInfo.status===3">
      <Row class="p-b-10">
        <i-col span="24">
          <span class="title text-title-85">实际收款日期 </span>
          {{ debtInfo.dueDate }}
        </i-col>
      </Row>
      <Row>
        <i-col span="24">
          <span class="title text-title-85">收款备注 </span>
          {{ debtInfo.dueRemark }}
        </i-col>
      </Row>
    </template>

    <Divider orientation="left" style="margin-bottom: 0px;">费用明细</Divider>
    <Alert>
      <p>
        全部费用总额：{{ formatMoney(statistics.total) }}
      </p>
      <p v-for="(item,index) in statistics.groupArray" :key="index" class="m-t-5">
        {{ item.assetName }}<Divider type="vertical" />
        <span v-for="(ele,index2) in item.data" :key="index2" class="m-r-10">
          {{ ele.feeTypeName }}：{{ formatMoney(ele.amount) }}
        </span>
      </p>
      <template v-if="query.startDate||query.endDate">
        <Divider style="margin: 10px 0;"/>
        <p>
          当前查询日期内账单总额：{{ formatMoney(statisticsByCondition.total) }}
        </p>
        <p v-for="(item,index) in statisticsByCondition.groupArray" :key="'condi'+index" class="m-t-5">
          {{ item.assetName }}<Divider type="vertical" />
          <span v-for="(ele,index2) in item.data" :key="index2" class="m-r-10">
            {{ ele.feeTypeName }}：{{ formatMoney(ele.amount) }}
          </span>
        </p>
      </template>
    </Alert>
    <Row v-if="debtInfo.status!==3">
      <i-col span="24" class="m-b-5">
        <a v-if="selectedIds.length>0" @click="handleBatchDelete"><Icon type="ios-trash-outline" />批量移除账单</a>
        <span v-else class="remark" style="cursor: no-drop;"><Icon type="ios-trash-outline" />批量移除账单</span>
        <Divider type="vertical" />
        <a @click="handleChoiceBill"><Icon type="md-add" />添加账单</a>
      </i-col>
    </Row>
    <Table stripe :columns="columnData" size="small" :data="tableData"
      @on-selection-change="selectionChange"
      :loading="tableLoading"
    ></Table>
    <div class="paging_style">
      <Page size="small" show-total show-elevator :current="query.pageNumber" :page-size="query.pageSize" :total="total" @on-change="handlePageNumberChange"></Page>
    </div>

    <finishDebtModal  ref="finishDebtModal" @on-success="initDetail"></finishDebtModal>
    <choiceBillModal  ref="choiceBillModal" @on-success="initDebtList" ></choiceBillModal>

    <Modal v-model="modalChangeMoney" width="400">
      <p slot="header" class="text-center">设置调差项</p>
      <Row class="p-b-10">
        <i-col span="4"><span class="title text-title-65">总额</span></i-col>
        <i-col span="20">
          {{ formatMoney(debtInfo.amount) }}
        </i-col>
      </Row>

      <Row class="p-b-10">
        <i-col span="4"><span class="title text-title-65">调差额</span></i-col>
        <i-col span="20">
          <InputNumber :max="100000000" style="width: 140px;" v-model="changeBean.adjustAmount"></InputNumber>
        </i-col>
      </Row>

      <Row class="p-b-10">
        <i-col span="4"><span class="title text-title-65">调差备注</span></i-col>
        <i-col span="20">
          <Input v-model="changeBean.adjustRemark" maxlength="500" :rows="4" show-word-limit type="textarea" placeholder="请输入调整备注信息..." style="width: 300px" />
        </i-col>
      </Row>

      <div slot="footer">
        <Button type="text" class="m-r-5" @click="modalChangeMoney = false">取消</Button>
        <Button type="primary" @click="handleSubmitChange">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import finishDebtModal from './FinishDebt.vue'
import choiceBillModal from './ChoiceBill.vue'

import { toMoney } from '@/utils/wnumb_own'
import { downloadFileRequest } from '@/utils/download'
/** new api */
import { getDebt, listDetailByDebt, adjustDebtAmount, delDebtDetail } from '@/api/invest/debt'

export default {
  components: {
    finishDebtModal, choiceBillModal
  },
  props: {},
  data () {
    return {
      debtInfo: {},
      feeData: [],

      modalChangeMoney: false,
      changeBean: {
        adjustAmount: 0,
        adjustRemark: '',
        debtId: null
      },

      query: {
        pageNumber: 1,
        pageSize: 12
      },

      statistics: {
        total: 0,
        groupArray: []
      },

      selectedIds: [],
      total: 0,
      tableLoading: false,
      baseTableData: [],
      showTableData: [],
      tableData: [],
      columnData: [
        { type: 'selection', width: 60, align: 'center' },
        { title: '标的物名称', key: 'objectName' },
        { title: '所属线路', key: 'assetName' },
        { title: '所在站点', key: 'stationName' },
        { title: '开始日期', key: 'startDate' },
        { title: '结束日期', key: 'endDate' },
        { title: '费用类型', key: 'feeTypeName' },
        {
          title: '账单金额',
          key: 'amount',
          render: (h, params) => {
            return h('strong', {
              attrs: {
                style: 'color:#44bd32'
              }
            },
            toMoney(params.row.amount))
          }
        }
      ]
    }
  },
  mounted () {},
  created () {
    if (this.receiptId) {
      this.initDetail()
      this.initDebtList()
    }
  },
  methods: {
    formatMoney (number) {
      return toMoney(number)
    },
    initDetail () {
      getDebt({ debtId: this.receiptId }).then((res) => {
        if (res) {
          this.debtInfo = res
          if (res.status === 3) { // 已收款，隐藏第一个列
            this.columnData.splice(0, 1)
          }
        }
      })
    },
    showDeviceList () {
      this.deviceListModal = true
    },
    initDebtList () {
      this.tableLoading = true
      listDetailByDebt({ debtId: this.receiptId }).then(res => {
        this.baseTableData = res
        this.tableLoading = false
        this.handleSearch()
        this.getTotalData()
        this.getStatisticsData()
      })
    },
    handleSearch () {
      // 这里设置查询条件
      // do something
      this.showTableData = this.baseTableData

      this.total = this.showTableData.length
      this.handlePageNumberChange(1)
    },
    handlePageNumberChange (page) {
      this.query.pageNumber = page
      const startRow = (this.query.pageNumber - 1) * this.query.pageSize
      const getRows = startRow + this.query.pageSize
      const pageData = []

      for (let index = startRow; index < getRows; index++) {
        if (index < this.showTableData.length) {
          pageData.push(this.showTableData[index])
        }
      }

      // 需要自动勾选被选中的项
      pageData.forEach(item => {
        item._checked = this.selectedIds.includes(item.id)
      })

      this.tableData = pageData
    },
    getTotalData () { // 获取费用清单统计数据
      const totalData = []
      let totalRow = null

      this.baseTableData.forEach(element => {
        totalRow = totalData.find(x => x.feeTypeName === element.feeTypeName)
        if (totalRow) {
          totalRow.amount += element.amount
        } else {
          totalData.push({
            feeTypeName: element.feeTypeName,
            amount: element.amount
          })
        }
      })

      this.feeData = totalData
    },
    getStatisticsData () {
      const group = ['全部']
      const groupAsset = []
      this.statistics = {
        total: 0,
        groupArray: []
      }
      this.baseTableData.forEach(element => {
        if (!groupAsset.includes(element.assetName)) {
          groupAsset.push(element.assetName)
        }
        if (!group.includes(element.feeTypeName)) {
          group.push(element.feeTypeName)
        }
        // 统计账单总额
        this.statistics.total += element.amount
      })

      // 开始计算线路数据
      let assetData = []
      let curAssetDataByFeeType = null
      let assetDataByFeeType = []

      groupAsset.forEach(element => {
        assetDataByFeeType = []
        assetData = this.baseTableData.filter(x => x.assetName === element)

        assetData.forEach(assetItem => {
          curAssetDataByFeeType = assetDataByFeeType.find(x => x.feeTypeName === assetItem.feeTypeName)
          if (curAssetDataByFeeType) {
            curAssetDataByFeeType.amount += assetItem.amount
          } else {
            assetDataByFeeType.push({
              feeTypeName: assetItem.feeTypeName,
              amount: assetItem.amount
            })
          }
        })

        this.statistics.groupArray.push({
          assetName: element,
          data: assetDataByFeeType
        })
      })
    },
    hanhandleChangeMoney () {
      this.modalChangeMoney = true
      this.changeBean.debtId = this.receiptId
      this.changeBean.adjustAmount = this.debtInfo.adjustAmount
      this.changeBean.adjustRemark = this.debtInfo.adjustRemark
    },
    handleSubmitChange () {
      adjustDebtAmount(this.changeBean).then(res => {
        if (res && res.success) {
          this.initDetail()
          this.$Notice.success({ desc: '设置调差项成功！' })
          this.modalChangeMoney = false
        }
      })
    },
    handleChoiceBill () {
      this.$refs.choiceBillModal.showModal(this.debtInfo.contractId)
    },
    handleFinishDebt () {
      this.$refs.finishDebtModal.showModal(this.receiptId)
    },
    handleExportNotify () {
      const fileName = '缴费通知单.docx'
      const query = {
        debtId: this.receiptId
      }

      downloadFileRequest(process.env.VUE_APP_API_URL_V2 + '/ooh-invest/v1/debt/exportDebtNotice', query, fileName)
    },
    selectionChange (selections) {
      const curSelection = selections.map(x => x.id)
      this.tableData.forEach(item => {
        // 当前被勾选
        if (curSelection.includes(item.id)) {
          if (!this.selectedIds.includes(item.id)) {
            this.selectedIds.push(item.id)
          }
        } else {
          // 当前未被勾选， 且存在勾选清单，那么移除
          if (this.selectedIds.includes(item.id)) {
            const index = this.selectedIds.findIndex(x => x === item.id)
            this.selectedIds.splice(index, 1)
          }
        }
      })
    },
    handleBatchDelete () {
      this.$Modal.confirm({
        title: '确定删除？',
        content: '<p>确定要批量删除账单吗？</p>',
        loading: true,
        onOk: () => {
          const deleteBean = {
            debtId: this.receiptId,
            detailIds: this.selectedIds.join(',')
          }

          delDebtDetail(deleteBean).then(res => {
            if (res && res.success) {
              this.$Notice.success({ desc: '操作成功' })
              this.initDebtList()
            }
          }).finally(() => {
            this.$Modal.remove()
          })
        }
      })
    }
  },
  watch: {
    spaceId () {
      this.initDetail()
    },
    beginUpdate () {
      this.initDetail()
    }
  },
  computed: {
    receiptId () {
      return this.$store.state.receipts.receiptId
    },
    beginUpdate () {
      return this.$store.state.receipts.beginUpdate
    },
    debtTotalAmount () {
      let total = this.debtInfo.adjustAmount

      this.feeData.forEach(element => {
        total += element.amount
      })

      return toMoney(total)
    }
  }
}
</script>
